// Where a new table goes on the floor plan (Oct 2026 sweep): straight onto the plan, not a
// holding row of chips to drag from.

/** The clearest spot on the plan for a new table: of a grid of candidates, the one furthest
 *  from every placed table (percent of the plan, like positions). An empty area gets the
 *  middle. */
export function freeSpot(tables, features = []) {
  const placed = tables.filter((t) => t.position_x > 0 || t.position_y > 0);
  // Not on top of the bar, the kitchen or the toilets: a few points of margin round each.
  const onFixture = (x, y) => features.some((f) => f.kind !== 'label'
    && x > f.x - 4 && x < f.x + f.w + 4 && y > f.y - 4 && y < f.y + f.h + 4);
  if (!placed.length && !onFixture(50, 50)) return { x: 50, y: 50 };
  let best = { x: 50, y: 50, d: -1 };
  for (let x = 12; x <= 88; x += 8) {
    for (let y = 14; y <= 86; y += 8) {
      if (onFixture(x, y)) continue;
      if (!placed.length) return { x, y };
      const d = Math.min(...placed.map((t) => Math.hypot(t.position_x - x, t.position_y - y)));
      if (d > best.d) best = { x, y, d };
    }
  }
  return { x: best.x, y: best.y };
}
